import PestPillarLayout from "./PestPillarLayout";

const PROBLEMS = [
  {
    title: "Vapeur sèche 180 °C — sans chimique",
    desc: "Méthode principale pour hôtels et gîtes : aucun produit chimique, aucune éviction du client, résultat immédiat. Idéal pour préserver votre image de marque et éviter les avis négatifs.",
  },
  {
    title: "Intervention discrète",
    desc: "Nous intervenons en journée hors périodes d'occupation, ou en soirée après check-out. Véhicule non marqué disponible sur demande. Confidentialité contractuelle.",
  },
  {
    title: "Contrat annuel de prévention",
    desc: "2 à 4 passages de contrôle par an (matelas, sommiers, plinthes), intervention prioritaire en cas de suspicion, tarifs contractuels avantageux. Idéal pour groupes hôteliers.",
  },
  {
    title: "Certificat HACCP compatible",
    desc: "Attestation d'intervention détaillée remise systématiquement (méthode, produits éventuels, zones traitées). Utile pour vos audits et responsabilité juridique.",
  },
  {
    title: "Traitement complet du linge",
    desc: "Vapeur sèche sur matelas + oreillers + couettes + tapis de sol + plinthes + rideaux. Aucune chambre laissée au hasard. Peut être combiné avec traitement des colonnes montantes en immeuble.",
  },
  {
    title: "Réponse urgence 24h",
    desc: "En pleine saison touristique, chaque nuit vide = pertes sèches. Notre engagement : diagnostic sous 24 h, intervention sous 48 h, chambre à nouveau exploitable en 4-6 h.",
  },
];

const METHOD = [
  { title: "Audit initial", desc: "Visite discrète de votre établissement : nombre de chambres, matelas, points sensibles. Devis contractuel détaillé sous 24h." },
  { title: "Passage préventif", desc: "1er passage vapeur sèche complet, généralement en journée d'inter-saison. Chaque chambre traitée reçoit un certificat." },
  { title: "Contrôles annuels", desc: "2 à 4 visites/an selon contrat, avec inspection matelas + traitement systématique des chambres à risque." },
  { title: "Urgence prioritaire", desc: "En cas de suspicion ou signalement client : intervention sous 48h max, chambre à nouveau exploitable rapidement." },
];

const FAQ = [
  {
    q: "Un client m'a signalé des punaises. Que faire immédiatement ?",
    a: "1) Sortir la chambre du planning immédiatement (ne pas relouer). 2) Ne pas déplacer les affaires du client dans une autre chambre. 3) Nous appeler dans l'heure : nous intervenons sous 24-48 h avec vapeur sèche. 4) Ne PAS utiliser de bombe insecticide — cela disperse les punaises et complique le traitement. 5) Conserver draps et taies pour analyse.",
  },
  {
    q: "Faut-il fermer l'établissement ?",
    a: "Non, dans la majorité des cas. Seule la chambre concernée est sortie du planning le temps du traitement (4-6 h avec la vapeur sèche). Les autres chambres continuent normalement leur activité. Notre approche est conçue pour ne PAS interrompre votre activité.",
  },
  {
    q: "Combien coûte un contrat annuel pour un hôtel ?",
    a: "Cela dépend du nombre de chambres et de la fréquence : pour un établissement de 8-15 chambres, comptez 800-1500 €/an pour 2 passages de contrôle (matelas + points sensibles). Pour 20-40 chambres, 1500-3000 €/an. Le contrat inclut l'intervention urgence prioritaire (2 chambres/an sans surcoût). Devis personnalisé après visite.",
  },
  {
    q: "Comment garantir la confidentialité ?",
    a: "Confidentialité contractuelle systématique. Nous pouvons intervenir avec véhicule non marqué et technicien en civil si vous le souhaitez, particulièrement en cas de client sur place. Nous ne publions jamais de références clients hôteliers sans accord écrit.",
  },
  {
    q: "Ma responsabilité en tant qu'hôtelier ?",
    a: "En France, l'hôtelier est responsable de fournir un logement propre et sans nuisible. Un client peut demander l'annulation avec remboursement, laisser un avis négatif, ou engager votre responsabilité civile. Un contrat de prévention documenté est la meilleure protection juridique (preuve de diligence).",
  },
  {
    q: "Intervenez-vous dans les campings et chambres d'hôtes ?",
    a: "Oui, absolument. Nous accompagnons également les gîteurs, campings (mobil-homes, bungalows), chambres d'hôtes et propriétaires de locations saisonnières (Airbnb, Booking) en Creuse et alentours. Contrats adaptés à votre modèle et saisonnalité.",
  },
];

export default function PunaisesLitHotelsGites() {
  return (
    <PestPillarLayout
      slug="punaises-de-lit-hotels-gites-creuse"
      seoTitle="Punaises de lit hôtels & gîtes Creuse | K'REUSE EXTÉRIEUR"
      seoDescription="Punaises de lit en hôtels, gîtes et chambres d'hôtes Creuse. Vapeur sèche 180°C, discrétion, contrat annuel, urgence 24h. 07 80 54 11 15."
      breadcrumbLabel="Punaises de lit hôtels & gîtes"
      heroBadge="Hôtellerie · Gîtes · Chambres d'hôtes"
      heroTitleHtml={`Punaises de lit : votre <span class="font-medium text-[#1B5E20]">réputation en jeu</span>`}
      heroSubtitle="Un signalement = risque d'avis négatif catastrophique sur Google/Booking. Nos contrats de prévention pour hôteliers, gîteurs et chambres d'hôtes en Creuse. Vapeur sèche 180 °C, intervention discrète sous 24-48 h."
      hero_h2="Un service anti-punaises taillé pour les professionnels du tourisme"
      introParagraphs={[
        "En France, 1 hôtel sur 3 signale au moins un incident de punaises de lit par an. Un seul avis négatif « il y avait des punaises » suffit à faire chuter votre note Booking de 0.5 point — et vous coûte des milliers d'euros de nuits non vendues.",
        "K'REUSE EXTÉRIEUR propose aux hôteliers, gîteurs et chambres d'hôtes de Creuse un service dédié combinant prévention (contrôles annuels), traitement (vapeur sèche 180 °C sans éviction), et urgence sous 24-48 h. Confidentialité contractuelle, véhicule non marqué disponible, attestation HACCP-compatible remise.",
        "Certifié Certibiocide, basé à La Celle-Dunoise (23800), Kevin intervient dans toute la Creuse et les départements limitrophes (Haute-Vienne, Indre, Allier). Vos clients ne verront rien, vous serez tranquille.",
      ]}
      problems={PROBLEMS}
      method={METHOD}
      cities={["Guéret", "Aubusson", "La Souterraine", "Bourganeuf", "Boussac", "Felletin", "Bénévent-l'Abbaye", "Dun-le-Palestel", "Sainte-Feyre", "La Celle-Dunoise"]}
      faq={FAQ}
      ctaTitle="Protégez votre réputation. Parlons-en."
      whatsappText="Bonjour, je gère un hôtel/gîte/chambre d'hôtes et je souhaite un devis contrat de prévention punaises de lit."
    />
  );
}
